import { createContext } from 'react';
import type { FeatureFlagContextValue } from '@/types/context/feature-flag-context.types';

export const FeatureFlagContext = createContext<FeatureFlagContextValue | null>(
  null
);
